import styled from '@emotion/styled'
import { theme } from '@dasa-health/components-react'

import { userBrowserDetect, userDeviceDetect } from 'utils'

const { isSafari } = userBrowserDetect()
const { isIos } = userDeviceDetect()

const isPortableSafari = isSafari && isIos
export const StyledForm = styled.div`
    height: 100%;
    display: flex;
    flex-direction: column;
    max-width: 434px;

    > form {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        height: 100%;
    }

    .form__cpf {
        margin-top: 1.5rem;
    }

    .form__cpf > .form__cpf__field {
        margin-bottom: 36px;

        & > h6 {
            margin-bottom: -20px;
        }
    }

    form {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        height: 100%;
        ${isPortableSafari && 'max-height: 280px;'}
    }

    .form__helper-button {
        display: flex;
        justify-content: flex-end;
        cursor: pointer;

        span {
            color: ${theme.colors.grays[50]};
            font-size: 12px;
            padding: 4px;
        }
    }

    button {
        width: 100%;

        @media screen and (min-width: ${theme.breakpoints[0]}) and (max-width: ${theme.breakpoints[2]}) {
            margin-top: 152px;
        }

        @media screen and (min-width: ${theme.breakpoints[2]}) {
            margin-top: 97px;
        }
    }

    @media screen and (min-width: ${theme.breakpoints[2]}) {
        width: 434px;

        form {
            display: initial;
            height: initial;
        }
    }

    .box {
        margin-bottom: 0;

        & + footer button {
            margin-top: 0;
        }
    }

    footer {
        display: flex;
        flex-direction: column;
        align-items: center;
        height: 100%;
        justify-content: flex-end;
        margin-top: 56px;

        @media screen and (min-width: ${theme.breakpoints[0]}) {
            height: initial;
        }
    }
`
